// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.background_ffAKi {
  position : absolute;
  top : 0;
  bottom : 0;
  right : 0;
  left : 0;
}

.onlyClickMe_Oy0eW { 
  height : 100%;
  pointer-events: none !important;
}
.onlyClickMe_Oy0eW > * { 
  pointer-events: all;
}


.sidebar_ywfUK {
}

.sidebarLeft_IyCPt {
  position : absolute;
  top : 0;
  left : 0;
  bottom : 0;
}

.sidebarCenter_vhweh {
  position : absolute;
  top : 0;
  right : 0;
  bottom : 0;
  left : 0;
  display: flex;
  align-items: center;
  justify-content: center
}

.sidebarFull_BiWfU {
  position : absolute;
  top : 0;
  right : 0;
  bottom : 0;
  left : 0;
}


.sidebarRight_l278_ {
  position : absolute;
  top : 0;
  right : 0;
  bottom : 0;
}

.sidebarTop_c6pDA {
  position : absolute;
  top : 0;
  left : 0;
  right : 0;
}

.sidebarBottom_ubvQk {
  position : absolute;
  bottom : 0;
  left : 0;
  right : 0;
}

.fadeEnter_fq4md {
  opacity: 0;
  animation-fill-mode: forwards;

}
.fadeEnterActive_B41ki {
  opacity: 1;
  transition: opacity 300ms;
}
.fadeExit_XYnbw {
  opacity: 1;
}
.fadeExitActive_hweGi {
  opacity: 0;
  transition: opacity 300ms;
}



.slideFromRightEnter_Jw6iE {
  opacity: 0;
  transform: translateX(100%);
}
.slideFromRightEnterActive_LUASw {
  opacity: 1;
  transform: translateX(0);
  transition: opacity 300ms, transform 300ms;
}
.slideFromRightExit_P3YVT {
  opacity: 1;
}
.slideFromRightExitActive_UTFN1 {
  transform: translateX(100%);
  opacity: 0;
  transition: opacity 300ms, transform 300ms;
}


.slideFromLeftEnter_i1U1H {
  opacity: 0;
  transform: translateX(-100%);
}
.slideFromLeftEnterActive_sQgqI {
  opacity: 1;
  transform: translateX(0);
  transition: opacity 300ms, transform 300ms;
}
.slideFromLeftExit_WmBun {
  opacity: 1;
}
.slideFromLeftExitActive_zA_PC {
  transform: translateX(-100%);
  opacity: 0;
  transition: opacity 300ms, transform 300ms;
}


.slideFromBottomEnter_PNDsO {
  opacity: 0;
  transform: translateY(100%);
}
.slideFromBottomEnterActive_PLI_6 {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 300ms, transform 300ms;
}
.slideFromBottomExit_HwRq6 {
  opacity: 1;
}
.slideFromBottomExitActive_Fblx3 {
  transform: translateY(100%);
  opacity: 0;
  transition: opacity 300ms, transform 300ms;
}


.slideFromTopEnter_vmoXc {
  opacity: 0;
  transform: translateY(-100%);
}
.slideFromTopEnterActive_NIgt3 {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 300ms, transform 300ms;
}
.slideFromTopExit_dMp5o {
  opacity: 1;
}
.slideFromTopExitActive_Zf80N {
  transform: translateY(-100%);
  opacity: 0;
  transition: opacity 300ms, transform 300ms;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/screens/main/actions/StackOverlay.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,OAAO;EACP,UAAU;EACV,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;AACA;EACE,mBAAmB;AACrB;;;AAGA;AACA;;AAEA;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,OAAO;EACP,SAAS;EACT,UAAU;EACV,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB,OAAO;EACP,SAAS;EACT,UAAU;EACV,QAAQ;AACV;;;AAGA;EACE,mBAAmB;EACnB,OAAO;EACP,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,UAAU;EACV,6BAA6B;;AAE/B;AACA;EACE,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,yBAAyB;AAC3B;;;;AAIA;EACE,UAAU;EACV,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,wBAAwB;EACxB,0CAA0C;AAC5C;AACA;EACE,UAAU;AACZ;AACA;EACE,2BAA2B;EAC3B,UAAU;EACV,0CAA0C;AAC5C;;;AAGA;EACE,UAAU;EACV,4BAA4B;AAC9B;AACA;EACE,UAAU;EACV,wBAAwB;EACxB,0CAA0C;AAC5C;AACA;EACE,UAAU;AACZ;AACA;EACE,4BAA4B;EAC5B,UAAU;EACV,0CAA0C;AAC5C;;;AAGA;EACE,UAAU;EACV,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,wBAAwB;EACxB,0CAA0C;AAC5C;AACA;EACE,UAAU;AACZ;AACA;EACE,2BAA2B;EAC3B,UAAU;EACV,0CAA0C;AAC5C;;;AAGA;EACE,UAAU;EACV,4BAA4B;AAC9B;AACA;EACE,UAAU;EACV,wBAAwB;EACxB,0CAA0C;AAC5C;AACA;EACE,UAAU;AACZ;AACA;EACE,4BAA4B;EAC5B,UAAU;EACV,0CAA0C;AAC5C","sourcesContent":[".background {\n  position : absolute;\n  top : 0;\n  bottom : 0;\n  right : 0;\n  left : 0;\n}\n\n.onlyClickMe { \n  height : 100%;\n  pointer-events: none !important;\n}\n.onlyClickMe > * { \n  pointer-events: all;\n}\n\n\n.sidebar {\n}\n\n.sidebarLeft {\n  position : absolute;\n  top : 0;\n  left : 0;\n  bottom : 0;\n}\n\n.sidebarCenter {\n  position : absolute;\n  top : 0;\n  right : 0;\n  bottom : 0;\n  left : 0;\n  display: flex;\n  align-items: center;\n  justify-content: center\n}\n\n.sidebarFull {\n  position : absolute;\n  top : 0;\n  right : 0;\n  bottom : 0;\n  left : 0;\n}\n\n\n.sidebarRight {\n  position : absolute;\n  top : 0;\n  right : 0;\n  bottom : 0;\n}\n\n.sidebarTop {\n  position : absolute;\n  top : 0;\n  left : 0;\n  right : 0;\n}\n\n.sidebarBottom {\n  position : absolute;\n  bottom : 0;\n  left : 0;\n  right : 0;\n}\n\n.fadeEnter {\n  opacity: 0;\n  animation-fill-mode: forwards;\n\n}\n.fadeEnterActive {\n  opacity: 1;\n  transition: opacity 300ms;\n}\n.fadeExit {\n  opacity: 1;\n}\n.fadeExitActive {\n  opacity: 0;\n  transition: opacity 300ms;\n}\n\n\n\n.slideFromRightEnter {\n  opacity: 0;\n  transform: translateX(100%);\n}\n.slideFromRightEnterActive {\n  opacity: 1;\n  transform: translateX(0);\n  transition: opacity 300ms, transform 300ms;\n}\n.slideFromRightExit {\n  opacity: 1;\n}\n.slideFromRightExitActive {\n  transform: translateX(100%);\n  opacity: 0;\n  transition: opacity 300ms, transform 300ms;\n}\n\n\n.slideFromLeftEnter {\n  opacity: 0;\n  transform: translateX(-100%);\n}\n.slideFromLeftEnterActive {\n  opacity: 1;\n  transform: translateX(0);\n  transition: opacity 300ms, transform 300ms;\n}\n.slideFromLeftExit {\n  opacity: 1;\n}\n.slideFromLeftExitActive {\n  transform: translateX(-100%);\n  opacity: 0;\n  transition: opacity 300ms, transform 300ms;\n}\n\n\n.slideFromBottomEnter {\n  opacity: 0;\n  transform: translateY(100%);\n}\n.slideFromBottomEnterActive {\n  opacity: 1;\n  transform: translateY(0);\n  transition: opacity 300ms, transform 300ms;\n}\n.slideFromBottomExit {\n  opacity: 1;\n}\n.slideFromBottomExitActive {\n  transform: translateY(100%);\n  opacity: 0;\n  transition: opacity 300ms, transform 300ms;\n}\n\n\n.slideFromTopEnter {\n  opacity: 0;\n  transform: translateY(-100%);\n}\n.slideFromTopEnterActive {\n  opacity: 1;\n  transform: translateY(0);\n  transition: opacity 300ms, transform 300ms;\n}\n.slideFromTopExit {\n  opacity: 1;\n}\n.slideFromTopExitActive {\n  transform: translateY(-100%);\n  opacity: 0;\n  transition: opacity 300ms, transform 300ms;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"background": `background_ffAKi`,
	"onlyClickMe": `onlyClickMe_Oy0eW`,
	"sidebar": `sidebar_ywfUK`,
	"sidebarLeft": `sidebarLeft_IyCPt`,
	"sidebarCenter": `sidebarCenter_vhweh`,
	"sidebarFull": `sidebarFull_BiWfU`,
	"sidebarRight": `sidebarRight_l278_`,
	"sidebarTop": `sidebarTop_c6pDA`,
	"sidebarBottom": `sidebarBottom_ubvQk`,
	"fadeEnter": `fadeEnter_fq4md`,
	"fadeEnterActive": `fadeEnterActive_B41ki`,
	"fadeExit": `fadeExit_XYnbw`,
	"fadeExitActive": `fadeExitActive_hweGi`,
	"slideFromRightEnter": `slideFromRightEnter_Jw6iE`,
	"slideFromRightEnterActive": `slideFromRightEnterActive_LUASw`,
	"slideFromRightExit": `slideFromRightExit_P3YVT`,
	"slideFromRightExitActive": `slideFromRightExitActive_UTFN1`,
	"slideFromLeftEnter": `slideFromLeftEnter_i1U1H`,
	"slideFromLeftEnterActive": `slideFromLeftEnterActive_sQgqI`,
	"slideFromLeftExit": `slideFromLeftExit_WmBun`,
	"slideFromLeftExitActive": `slideFromLeftExitActive_zA_PC`,
	"slideFromBottomEnter": `slideFromBottomEnter_PNDsO`,
	"slideFromBottomEnterActive": `slideFromBottomEnterActive_PLI_6`,
	"slideFromBottomExit": `slideFromBottomExit_HwRq6`,
	"slideFromBottomExitActive": `slideFromBottomExitActive_Fblx3`,
	"slideFromTopEnter": `slideFromTopEnter_vmoXc`,
	"slideFromTopEnterActive": `slideFromTopEnterActive_NIgt3`,
	"slideFromTopExit": `slideFromTopExit_dMp5o`,
	"slideFromTopExitActive": `slideFromTopExitActive_Zf80N`
};
export default ___CSS_LOADER_EXPORT___;
